import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FetchDataService } from 'src/app/core/services/fetch-data.service';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-switch-role',
  templateUrl: './switch-role.component.html',
  styleUrls: ['./switch-role.component.scss']
})
export class SwitchRoleComponent implements OnInit {
registerForm!: FormGroup;
  profileData: any;
  hideRest = true;
  uid: any;
  token: any;
  pendingType: any;

  switchSuccess: boolean = false; 

  constructor(
    private fb: FormBuilder,
    private fdService: FetchDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
 ngOnInit(): void {

    this.uid = localStorage.getItem('uid');
    this.token = localStorage.getItem('token');

    this.pendingType = this.route.snapshot.queryParams['user_type'];

    this.initializeForm();
    this.loadProfileData();
  }

  initializeForm() {
    this.registerForm = this.fb.group({
      id: [''],
      email: [''],
      first_name: [''],
      last_name: [''],
      country: [''],
      country_code: [''],
      phone: [''],
      register_as: [''],
      companies: [''],
      acceptTerms: [false, Validators.requiredTrue]
    });
  }

  loadProfileData() {
    this.fdService
      .getProfileList(this.uid, this.token)
      .pipe(
        map((res: any) => {
          if (res.code == 1) {

            this.profileData = res.result;
console.log(this.profileData,"dataaaaaa");
            this.registerForm.patchValue({
              id: this.uid,
              email: this.profileData.email,
              first_name: this.profileData.first_name,
              last_name: this.profileData.last_name,
              country: this.profileData.country,
              country_code: this.profileData.country_code,
              phone: this.profileData.phone_number,
              companies: this.profileData.company_name,
              register_as: this.pendingType
            });

            // Disable all fields except checkbox
            Object.keys(this.registerForm.controls).forEach(key => {
              if (key !== 'acceptTerms') {
                this.registerForm.get(key)?.disable();
              }
            });

            this.hideRest = false;
          }
        })
      )
      .subscribe();
  }

//   onSubmit() {
// console.log(this.pendingType,"aaa");
//     if (this.registerForm.invalid) return;

//     const formData = new FormData();

//     formData.append("id", this.profileData.id);
//     formData.append("email", this.profileData.email);
//     formData.append("first_name", this.profileData.first_name);
//     formData.append("last_name", this.profileData.last_name);
//     formData.append("country", this.profileData.country);
//     formData.append("country_code", this.profileData.country_code);
//     formData.append("phone", this.profileData.phone_number);
//     formData.append("company_name", this.profileData.company_name || '');
//     formData.append("register_as", this.pendingType);
//     formData.append("acceptTerms", "true");

//     this.fdService.signup(formData).subscribe((res: any) => {
// console.log(this.pendingType,"aaa");

//       if (res.code == 1) {

//         Swal.fire({
//           icon: 'success',
//           title: 'Role switched successfully'
//         }).then(() => {

//           localStorage.setItem('userType', this.pendingType);
// console.log(this.pendingType,"aaa");

//           if (this.pendingType == '1') {
//             this.router.navigate(['/buyer/marketplace']);
//           } else {
//             this.router.navigate(['/seller/dashboard']);
//           }

//         });

//       }

//     });

//   }


submitSwitchRole() {
console.log(this.uid);
  if (this.registerForm.get('acceptTerms')?.invalid) return;

  const payload = {
    user_id: this.uid,     // ya login uid
    email: this.profileData.email,    // login email
    user_type: this.pendingType       // 1 or 2
  };

  this.fdService.createSecondUser(payload).subscribe(res => {

    if (res.code == 1) {

      this.switchSuccess = true;  // success message show karo

      // optionally role localStorage me update
      localStorage.setItem('userType', this.pendingType);
      Swal.fire({
                              position: 'top-end',
                              icon: 'success',
                              title: 'Your registration request has been received successfully. It takes less than 24 hours to review. You would be receiving an email with an update.',
                              showConfirmButton: true,  // Show OK button
                              confirmButtonText: 'OK'
                          }).then((result) => {
                              if (result.isConfirmed) {
                                  this.router.navigate(['/account/login']);
                              }
                          });
      

    } else {
    
      Swal.fire({
        icon: 'info',          
        title: res.message,    
        confirmButtonText: 'OK'
      });
    }

  });

}

}
